import styled, { css } from 'styled-components';

const triangleSize = 4;

export const Chevron = styled.div<{
	color: string;
	position: 'left' | 'right';
	additionalMarginLeft?: number;
}>`
	${({ color, position, additionalMarginLeft }) => css`
		width: 0;
		height: 0;
		box-sizing: border-box;
		transform-origin: center center;
		flex-shrink: 0;
		border-right: ${triangleSize}px solid ${color};
		border-top: ${triangleSize / 2}px solid transparent;
		border-bottom: ${triangleSize / 2}px solid transparent;
		${position === 'right'
			? css`
					transform: rotate(180deg);
					margin-right: 4px;
				`
			: css`
					margin-left: calc(4px + ${additionalMarginLeft ?? 0}px);
				`}
	`}
`;
